import React, { Children, cloneElement } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import PropTypes from 'prop-types';

import { BaseFlex } from '../layouts/Flex/Flex';
import { getInputStateType } from './Input/getInputStateType';

export const StyledInputIconContainer = styled(BaseFlex)((props) => {
  const type = getInputStateType(props);

  return css({
    px: '2x_small',
    color: `input.${type}.icon`,
    borderColor: `input.${type}.color`,
    backgroundColor: `input.${type}.bg`,
    alignItems: 'center',
  });
});

const InputIconContainer = ({
  children,
  disabled = false,
  focus = false,
  invalid = false,
  ...rest
}) => {
  return (
    <StyledInputIconContainer
      disabled={disabled}
      focus={focus}
      invalid={invalid}
      {...rest}
    >
      {cloneElement(Children.only(children), {
        color: 'inherit',
      })}
    </StyledInputIconContainer>
  );
};

InputIconContainer.propTypes = {
  /** must be an Icon */
  children: PropTypes.element,
  /** when the input is disabled */
  disabled: PropTypes.bool,
  /** when the input is focus */
  focus: PropTypes.bool,
  /** when the input is invalid */
  invalid: PropTypes.bool,
};

export default InputIconContainer;
